import { Controller } from "@hotwired/stimulus"

// Pushes dataLayer events on step transitions for GTM tracking.
// Lives INSIDE the Turbo Frame so it reconnects on each step change.
export default class extends Controller {
  static values = {
    step: String,
    stepNumber: Number,
    totalSteps: Number
  }

  connect() {
    this.pushStepView()
  }

  pushStepView() {
    // Single event per step — GTM triggers the right tags based on step_name/step_number
    this.push("virtual_page_view", {
      page_path: "/application/step/" + this.stepValue,
      step_name: this.stepValue,
      step_number: this.stepNumberValue,
      total_steps: this.totalStepsValue
    })
  }

  push(eventName, data = {}) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName, ...data })
  }
}
